export default __webpack_public_path__ + "static/media/FKGroteskNeue-Medium.0465b383.woff2";